<div class="__filters-wrap">
  <div class="__filters-grid">

    <div class="__filters-grid_item">

      <h3 class="__filters-title">Applications?</h3>

      <div class="__tags">
        <a
          *ngFor="let item of state.filterGroups?.application; trackBy: trackByIndex;"
          mat-button
          [routerLink]="[ '.' ]"
          [queryParams]="!state.activeFilterTagsMap || (state.activeFilterTagsMap && !state.activeFilterTagsMap[item.attributes.slug])
            ? (state.routerParams | routerParams: 'tags' : (state.activeFilterTagsParam ? (state.activeFilterTagsParam + ',' + item.attributes.slug) : item.attributes.slug))
            : (state.routerParams | routerParams: 'tags' : (state.activeFilterTagsParam | removeFromString : item.attributes.slug : ','))"
          [class.is-active]="state.activeFilterTagsMap[item.attributes.slug]"
          [class.is-disabled]="!state.enabledTagsMap[item.attributes.slug]"
          class="__tag"
          [ngClass]="'is-' + item.attributes.slug">
          <mat-icon class="__tag_icon" [svgIcon]="item.attributes.logo || undefined">{{ item.attributes.icon }}</mat-icon> {{ item.attributes.tag }}
        </a>
      </div>

    </div>

    <div class="__filters-grid_item">

      <h3 class="__filters-title">Running on?</h3>

      <div class="__tags">
        <a
          *ngFor="let item of state.filterGroups?.runtime; trackBy: trackByIndex;"
          mat-button
          [routerLink]="[ '.' ]"
          [queryParams]="!state.activeFilterTagsMap || (state.activeFilterTagsMap && !state.activeFilterTagsMap[item.attributes.slug])
            ? (state.routerParams | routerParams: 'tags' : (state.activeFilterTagsParam ? (state.activeFilterTagsParam + ',' + item.attributes.slug) : item.attributes.slug))
            : (state.routerParams | routerParams: 'tags' : (state.activeFilterTagsParam | removeFromString : item.attributes.slug : ','))"
          [class.is-active]="state.activeFilterTagsMap[item.attributes.slug]"
          [class.is-disabled]="!state.enabledTagsMap[item.attributes.slug]"
          class="__tag"
          [ngClass]="'is' + item.attributes.slug">
          <mat-icon class="__tag_icon" [svgIcon]="item.attributes.logo || undefined">{{ item.attributes.icon }}</mat-icon> {{ item.attributes.tag }}
        </a>
      </div>

    </div>

    <div class="__filters-grid_item">

      <h3 class="__filters-title">Using?</h3>

      <div class="__tags">
        <a
          *ngFor="let item of state.filterGroups?.other; trackBy: trackByIndex;"
          mat-button
          [routerLink]="[ '.' ]"
          [queryParams]="!state.activeFilterTagsMap || (state.activeFilterTagsMap && !state.activeFilterTagsMap[item.attributes.slug])
            ? (state.routerParams | routerParams: 'tags' : (state.activeFilterTagsParam ? (state.activeFilterTagsParam + ',' + item.attributes.slug) : item.attributes.slug))
            : (state.routerParams | routerParams: 'tags' : (state.activeFilterTagsParam | removeFromString : item.attributes.slug : ','))"
          [class.is-active]="state.activeFilterTagsMap[item.attributes.slug]"
          [class.is-disabled]="!state.enabledTagsMap[item.attributes.slug]"
          class="__tag"
          [ngClass]="'is' + item.attributes.slug">
          <mat-icon class="__tag_icon" [svgIcon]="item.attributes.logo || undefined">{{ item.attributes.icon }}</mat-icon> {{ item.attributes.tag }}
        </a>
      </div>

    </div>

  </div>

</div>

<ng-container *ngIf="!state.isLoading">

  <ng-container *ngIf="!!state.activeFilterTags?.length">

    <zui-separator class="__recipes-filter-separator" [spacing]="'big'" [size]="'medium'"></zui-separator>

    <div class="__recipes-grid" >
      <div
        class="__recipes-grid_item"
        *ngFor="let item of state.visibleFilteredRecipes; trackBy: trackByIndex;">
        <zui-recipe
          [zuiDynamicPopAnchor]="popoverRef"
          #ref="dynamicPopAnchor"
          [id]="item.id"
          [projectImportLoading]="!!state.projectImportProgress && state.projectImportProgress?.meta?.tag === item?.id"
          (importProjectClicked)="onImportProject$.next({
            devEnv: $event.devEnv,
            prodEnv: $event.prodEnv,
            item: item,
            anchor: $event.ref,
            ref: ref
          })"
          (showProjectYamlClicked)="
            onShowProjectYaml$.next({ data: item, mode: $event.mode });
            showYaml.emit($event.mode === 'ha' ? item.attributes.config_ha : item.attributes.config_nonha)"
          [priceNonha]="item.attributes.price_nonha"
          [priceHa]="item.attributes.price_ha"
          [guideSlug]="item.attributes.guide"
          [resourcesHa]="item.attributes.resources_ha"
          [resourcesNonha]="item.attributes.resources_nonha"
          [structure]="item.attributes.structure">
        </zui-recipe>
      </div>
    </div>

    <div class="__more-button-wrap" *ngIf="state.filteredRecipes?.length >= 4">
      <button
        type="button"
        class="c-button  c-button--full"
        mat-button
        (click)="showAllRecipes$.next(!state.showAllRecipes)">
        {{ !state.showAllRecipes ? 'Show more' : 'Show less' }}
        <mat-icon>{{ !state.showAllRecipes ? 'expand_more' : 'expand_less' }}</mat-icon>
      </button>
    </div>

  </ng-container>

</ng-container>

<sat-popover
  #popoverRef
  [zuiPopState]="authPopKey"
  [autoFocus]="false"
  [restoreFocus]="false"
  [verticalAlign]="'center'"
  [horizontalAlign]="'center'"
  hasBackdrop
  (backdropClicked)="popoverRef.close()">
  <mat-card class="__auth-pop-card  z-manual-elevation  c-soft-elevation">
    <ng-content></ng-content>
  </mat-card>
</sat-popover>
